import { fetchApi, type GenericRes } from '@hunk/shared/api/fetchApi';
import type { PaymentOptionType } from '@hunk/shared/common';

/** Payment options for the checkout + admin payment settings. Paying itself is per order (api/orders.ts). */

export interface BillingOptionsRes extends GenericRes {
  /** enabled by an admin AND configured on the server */
  paymentOptions?: PaymentOptionType[];
}

/** admin: payment options on / off, and which providers are configured in .env */
export interface PaymentSettings {
  enabled: PaymentOptionType[];
  configured: { tranzila: boolean; paypal: boolean };
}
export interface PaymentSettingsRes extends GenericRes {
  settings?: PaymentSettings;
}

type H = { headers?: HeadersInit };
export const getOptions = ({ headers }: H = {}) => fetchApi<{}, BillingOptionsRes>({ apiPath: '/api/billing/options', headers });
export const getPaymentSettings = ({ headers }: H) => fetchApi<{}, PaymentSettingsRes>({ apiPath: '/api/admin/paymentSettings', headers });
export const setPaymentOptions = (enabled: PaymentOptionType[], { headers }: H) =>
  fetchApi<{ enabled: PaymentOptionType[] }, PaymentSettingsRes>({ apiPath: '/api/admin/paymentSettings', method: 'PUT', data: { enabled }, headers });
